module.exports = __webpack_public_path__ + "media/images/icons/material/github-824c998d540a0849b15c90678d89aa7f.svg";